import type { ReactNode } from "react";
import { Brand } from "./brand";
import { LangToggle } from "./lang-toggle";

interface Props {
  formTitle: string;
  formSub?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
  hideLangToggle?: boolean;
}

export function AuthShell({ formTitle, formSub, children, footer, hideLangToggle }: Props) {
  return (
    <div className="acx__auth">
      <div className="acx__auth-card">
        <div className="acx__auth-brand"><Brand size="lg" /></div>
        <header className="acx__auth-header">
          <h1 className="acx__auth-title">{formTitle}</h1>
          {formSub && <p className="acx__auth-sub">{formSub}</p>}
        </header>
        {children}
        {footer && <p className="acx__auth-footer">{footer}</p>}
        {!hideLangToggle && <div className="acx__auth-shell-lang"><LangToggle /></div>}
      </div>
    </div>
  );
}
